import styled, { css } from 'styled-components';
import { FormCheckmark } from 'grommet-icons';

const StyledFormCheckmark = styled(FormCheckmark)`
    ${(props) => css`
        stroke: ${props.theme.global.colors.brand};
    `}
`;

export default StyledFormCheckmark;
